import { method as toBluebird } from "bluebird";
import { testSupported } from "./tester";
import { install } from "./installer";
import { VortexModInstallerLogger } from "./utils/VortexModInstallerLogger";
import { VortexModInstallerFileSystem } from "./utils/VortexModInstallerFileSystem";
let logger = null;
let fileSystem = null;
const main = (context) => {
    context.registerInstaller(
    /*id:*/ `fomod`, 
    /*priority:*/ 10, 
    /*testSupported:*/ toBluebird(async (files, _gameId, _archivePath, details) => {
        return await testSupported(files, details, false);
    }), 
    /*install:*/ toBluebird(async (files, destinationPath, gameId, _progressDelegate, choices, unattended, _archivePath, details) => {
        return await install(context.api, files, destinationPath, gameId, choices, unattended, details);
    }));
    context.registerInstaller(
    /*id:*/ `fomod`, 
    /*priority:*/ 100, 
    /*testSupported:*/ toBluebird(async (files, _gameId, _archivePath, details) => {
        return await testSupported(files, details, true);
    }), 
    /*install:*/ toBluebird(async (files, destinationPath, gameId, _progressDelegate, choices, unattended, _archivePath, details) => {
        return await install(context.api, files, destinationPath, gameId, choices, unattended, details);
    }));
    context.once(() => {
        context.api.onAsync("will-install-mod", async (_gameId, _archiveId, _modId) => {
            if (logger != null) {
                logger = new VortexModInstallerLogger();
                logger.useVortexFunctions();
            }
            if (fileSystem != null) {
                fileSystem = new VortexModInstallerFileSystem();
                fileSystem.useVortexFunctions();
            }
        });
    });
    return true;
};
export default main;
